import { FgBlockType } from '../../block-type.js';
import { FgType } from '../../types.js';
import { getDataValue, activateSignal } from '../../runtime.js';
import { sigOut, sigIn, sockIn } from '../../sockets.js';

const MAX_ITERATIONS = 1e3;
const whileLoopDef = {
  type: FgBlockType.WhileLoop,
  build: () => ({
    dataIn: [sockIn("condition", FgType.Boolean, false)],
    signalIn: [sigIn("in")],
    signalOut: [sigOut("executionFlow"), sigOut("completed")]
  }),
  execute(block, ctx, env) {
    const doWhile = !!block.config?.doWhile;
    let condition = doWhile || !!getDataValue(ctx, env, block, "condition");
    let i = 0;
    while (condition) {
      activateSignal(ctx, env, block, "executionFlow");
      if (++i >= MAX_ITERATIONS) {
        break;
      }
      condition = !!getDataValue(ctx, env, block, "condition");
    }
    activateSignal(ctx, env, block, "completed");
  }
};

export { whileLoopDef };
//# sourceMappingURL=while-loop.js.map
